import { Component, output } from '@angular/core';

@Component({
  selector: 'app-document-acknowledgement-alert',
  template: `
    <app-signing-room-dialog
      dialogTitle="One last step"
      message="Please confirm that you've reviewed all signed documents."
    >
      <app-button
        type="primary"
        [dataTestId]="'acknowledgement-confirm'"
        (buttonClick)="acknowledgeClick()"
      >
        Acknowledge and submit
      </app-button>
    </app-signing-room-dialog>
  `,
  standalone: false,
})
export class DocumentAcknowledgementAlertComponent {
  acknowledge = output();

  acknowledgeClick() {
    this.acknowledge.emit();
  }
}
